import { Button, Descriptions, Modal, ModalProps } from "antd"
import { IEventDetail } from "pages/events/types"
import { useTranslation } from "react-i18next"

interface Props extends ModalProps {
  data?: IEventDetail
  onClose: () => void
}

const EventDetailsModal: React.FC<Props> = ({ data, ...props }) => {
  const { t } = useTranslation()
  return (
    <Modal
      title={t("global.detailsX", {
        entity: t("events.event"),
        count: 0,
      })}
      onCancel={props.onClose}
      footer={[
        <Button key="cancel" onClick={() => props.onClose()}>
          {t("global.close")}
        </Button>,
      ]}
      {...props}
    >
      <Descriptions
        column={1}
        items={[
          data?.event_type === "entente"
            ? {
                key: "entente",
                label: t("labels.entente"),
                children: data?.entente?.name,
              }
            : {
                key: "session",
                label: t("labels.session"),
                children: data?.session.name,
              },
          {
            key: "name",
            label: t("labels.name"),
            children: data?.name,
          },
          {
            key: "status",
            label: t("labels.status"),
            children: data?.displayed_status,
          },
          {
            key: "enrollment_type",
            label: t("labels.enrollment_type"),
            children: data?.displayed_enrollment,
          },
          {
            key: "start_date",
            label: t("labels.start_date"),
            children: `${data?.start_date}, ${data?.start_hour}h`,
          },
          {
            key: "end_date",
            label: t("labels.end_date"),
            children: `${data?.end_date}, ${data?.end_hour}h`,
          },
          {
            key: "place",
            label: t("labels.place"),
            children: data?.place.name,
          },
          {
            key: "nb_of_members",
            label: t("global.number_of_X", {
              entity: t("members.title"),
            }),
            children: data?.nb_members,
          },
          {
            key: "nb_of_monitors",
            label: t("global.number_of_X", {
              entity: t("monitors.title"),
            }),
            children: data?.nb_monitors,
          },
        ]}
      />
    </Modal>
  )
}

export default EventDetailsModal
